// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

function getAllRateSetsForUserApi(query: string): any {
    let baseUrl = config.RATE_SETS_URL;

    if (query) {
        baseUrl += `?${query}`;
    }

    return api.get(`${baseUrl}`);
}

function getRatesForRateSetAdmin(id: string, carrierServiceId: string): any {
    return api.get(`${config.RATE_SETS_URL}/${id}/rates?carrier_service_id=${carrierServiceId}`);
}

export { getAllRateSetsForUserApi, getRatesForRateSetAdmin };
